<template>
  <landing-page-wrapper chamber="senate">
    <span slot="page-title">2018 Senate Elections</span>
    <!-- <span slot="page-description">Every two years, one-third of the Senate is up for re-election. With the current 51R-49D split in the Senate, 2018's Senate elections could flip control of the chamber to the Democrats. On one hand, the elections are being held in a political environment that is very favorable towards Democrats; on the other, they are playing defense in 26 races and only have 9 pickup opportunities. What follows is a presentation of our weekly forecasting model.</span> -->
  </landing-page-wrapper>
</template>

<script>
import { LandingPageWrapper } from '@/components'

const name = 'senate_landing'

const components = {
  LandingPageWrapper
}

export default {
  name,
  components,
  metaInfo: {
    title: 'Senate',
    meta: [
      {
        vmid: 'og:title',
        name: 'og:title',
        content: 'Senate'
      }, {
        vmid: 'twitter:title',
        name: 'twitter:title',
        content: 'Senate'
      }, {
        vmid: 'description',
        name: 'description',
        content: '2018 U.S. midterm elections predictions for Senate races. Incorporates polling, state characteristics, candidate traits, and election results to simulate 35 Senate races and which party will control the Senate.'
      }, {
        vmid: 'og:description',
        name: 'og:description',
        content: '2018 U.S. midterm elections predictions for Senate races. Incorporates polling, state characteristics, candidate traits, and election results to simulate 35 Senate races and which party will control the Senate.'
      }, {
        vmid: 'twitter:description',
        name: 'twitter:description',
        content: '2018 U.S. midterm elections predictions for Senate races. Incorporates polling, state characteristics, candidate traits, and election results to simulate 35 Senate races and which party will control the Senate.'
      }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/SenateLanding.vue